import React from 'react';

import Button from 'common/components/Button';
import { useRewindContext } from 'common/components/RewindModal/RewindContext';
import trans from 'common/tools/translations/trans';
import { trackShareRewindModal } from 'common/tracking/rewindModal';

type ShareButtonProps = {
  onClick: () => void;
  disabled?: boolean;
  text?: string;
  flashbackType?: number;
};

const ShareButton = ({
  onClick,
  disabled = false,
  text,
  flashbackType: flashbackTypeProp
}: ShareButtonProps) => {
  const {
    flashbackType: flashbackTypeContext,
    screenName,
    trackingScreenName
  } = useRewindContext();
  const flashbackType = flashbackTypeProp ?? flashbackTypeContext;

  const handleClick = () => {
    trackShareRewindModal({
      flashbackType,
      screenName: (trackingScreenName || screenName || '') as ScreenNames
    });
    onClick();
  };

  return (
    <Button onClick={handleClick} disabled={disabled} size="sm">
      <div className="icon icon-share-social share-button">
        {text || trans('rewind.end_screen.share.button')}
      </div>
    </Button>
  );
};

export default ShareButton;
